import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ISendStats, IStatus } from './types';

const statApi = createApi({
    reducerPath: 'statApi',
    baseQuery: fetchBaseQuery(),
    tagTypes: ['Consent'],
    endpoints: ({ query, mutation }) => ({
        sendStats: mutation<string, ISendStats>({
            query: ({ msisdn, accepted, timestamp }) => ({
                url: '/privacy/consent',
                method: 'POST',
                body: {
                    msisdn,
                    status: accepted ? 1 : 0,
                    timestamp,
                },
                headers: {
                    'content-type': 'application/json',
                },
            }),
            invalidatesTags: ['Consent'],
            async onQueryStarted({ msisdn, accepted }, { dispatch, queryFulfilled }) {
                const patchResult = dispatch(
                    statApi.util.updateQueryData('checkStatus', { msisdn }, (draft) => {
                        draft.status = accepted ? 1 : 0;
                    }),
                );

                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            },
        }),
        checkStatus: query<IStatus, { msisdn: number }>({
            query: ({ msisdn }) => ({
                url: `/privacy/consent?msisdn=${msisdn}`,
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                },
            }),
            providesTags: ['Consent'],
        }),
    }),
});

export default statApi;
